<template>
  <div class="graph-colors">
    <a-alert
      message="Negative values are invalid for a pie chart"
      banner
      closable
      v-if="negativeData"
    />

    <ul class="pie-legend">
      <li v-for="legend in legendData" :key="legend.label">
        <span :style="{ backgroundColor: legend.color }"></span
        >{{ legend.label }}
      </li>
    </ul>
    <doughnut
      :chartData="graphData"
      :options="options"
      ref="skills_chart"
      :height="350"
      :width="350"
      v-if="chartType === 'Doughnut'"
    />
    <pie
      :chartData="graphData"
      :options="options"
      ref="skills_chart"
      :height="350"
      :width="350"
      v-else
    />
  </div>
</template>

<script>
import randomcolor from "randomcolor";
import Doughnut from "./Doughnut.vue";
import Pie from "./Pie.vue";
export default {
  name: "ReportGraph",
  props: {
    chartData: Array,
    chartId: String,
    labelPropName: {
      default: "client_name",
      type: String,
    },
    dataPropName: {
      default: "points",
      type: String,
    },
    showDataLabels: {
      default: true,
      type: Boolean,
    },
    chartType: {
      type: String,
      default: "Doughnut",
    },
  },
  components: { Doughnut, Pie },
  data() {
    return {
      graphData: {},
      legendData: [],
      negativeData: false,
      options: {
        legend: {
          display: this.showDataLabels,
          labels: { boxWidth: 15 },
        },
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          animateRotate: false,
        },
        scaleBeginAtZero: true,
      },
    };
  },
  created() {
    this.options.legend.display = false;
  },
  methods: {
    updateChart() {
      this.$refs.skills_chart.update();
    },
  },
  watch: {
    chartData: {
      deep: true,
      immediate: true,
      handler(val, oldVal) {
        this.graphData = {
          labels: val.map(({ [this.labelPropName]: label }) => label),
          datasets: [
            {
              backgroundColor: val.map(() => randomcolor()),
              data: val.map(({ [this.dataPropName]: dataPoint }) => dataPoint),
            },
          ],
        };
        this.negativeData = val.some(
          ({ [this.dataPropName]: dataPoint }) => Number(dataPoint) < 0
        );
        this.legendData = val.map(({ [this.labelPropName]: label }, index) => ({
          label,
          color: this.graphData.datasets[0].backgroundColor[index],
        }));
        this.updateChart();
      },
    },
  },
};
</script>
<style lang="scss">
.ant-alert.ant-alert-closable {
  padding-right: 30px;
  width: 100%;
  text-align: center;
}
.graph-colors {
  .pie-legend ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .pie-legend span {
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 16px;
    margin-bottom: -2px;
  }

  .pie-legend li {
    margin-bottom: 10px;
    display: inline-block;
    margin-right: 10px;
  }

  canvas {
    width: 100% !important;
    height: auto !important;
  }

  .table {
    border: 1px solid red;
    display: table;
    width: 100%;
    table-layout: fixed;
  }

  .cell {
    display: table-cell;
    vertical-align: middle;
  }
}
</style>
